export class BeamerBroadcastChannel {
  public static readonly ChannelName = "beamer";

  public static readonly IncreaseFontSize = "+";
  public static readonly DecreaseFontSize = "-";
}
